module.exports = __webpack_public_path__ + "static/img/expellinginsects-active.7f9fe99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/expellinginsects-active.png
// module id = 5arC
// module chunks = 26